import useSite from "@casino/legacy/client/hooks/useSite";
import { useTelegramMutation } from "@workspace/casino_core/mutations/TelegramMutation.client";
import { useTelegramQuery } from "@workspace/casino_core/queries/TelegramQuery.client";

const useTelegram = () => {
  const { site, isSportsbet } = useSite();
  const variables = {
    site,
    name: isSportsbet ? "socialLoginTelegram" : "TelegramLogin",
  };
  const { loading, error, data } = useTelegramQuery({
    variables,
  });
  const [userManagementAuthWithTelegram, { loading: isSaving }] =
    useTelegramMutation();

  return { loading, error, data, isSaving, userManagementAuthWithTelegram };
};

export default useTelegram;
